{
  "evolution.overlay.hatched": "Your egg has hatched",
  "evolution.overlay.evolved": "Your Suikamon has Evolved",
  "evolution.overlay.tapToReveal": "✨ Tap to reveal! ✨",
  "evolution.ready": "Ready to evolve!",
  "evolution.button": "Evolve",
  "evolution.readyHatch": "Ready to hatch!",
  "evolution.readyStage": "Ready to evolve to stage {stage}!",
  "evolution.toast.signInToEvolve": "Please sign in to evolve your Suikamon.",
  "evolution.toast.inProgress": "Evolution already in progress…",
  "evolution.toast.failed": "Evolution failed.",
  "evolution.toast.hatching": "Hatching… 🥚",
  "evolution.toast.evolving": "Evolving… 🧬",
  "evolution.toast.levelingUp": "Leveling up… ⭐",
  "evolution.toast.syncFailed": "Sync failed: {reason}. Please refresh.",
  "evolution.toast.unknownReason": "unknown error",
  "evolution.toast.hatched": "Your egg hatched! 🎉",
  "evolution.toast.evolved": "Evolution complete! 🎉",
  "evolution.toast.leveledUp": "Level up complete! ⭐",
  "evolution.toast.syncFailedAfter": "Evolution succeeded but sync failed. Please refresh.",
  "evolution.toast.cancelled": "Evolution cancelled.",
  "evolution.toast.requestFailed": "Evolution request failed.",
  "evolution.egg.warm0": "Tap your egg to warm it!",
  "evolution.egg.warm1": "The egg feels your touch… Keep tapping!",
  "evolution.egg.warm2": "Something is stirring inside… One more tap!",
  "evolution.egg.ready": "Your pet is ready to hatch!",
  "evolution.egg.alt": "Suikamon Egg",
  "evolution.egg.touchMe": "👆 Touch Me!",
  "evolution.egg.badge": "Egg",
  "evolution.egg.warmButton": "🤲 Warm the Egg ({taps}/{needed})",
  "evolution.egg.hatching": "Hatching…",
  "evolution.egg.hatch": "🐣 Hatch Your Pet!",
  "evolution.egg.donateLink": "Donate Egg (+{suika} SUIKA)",
  "evolution.egg.donateTitle": "Donate Egg",
  "evolution.egg.donateDescription": "Donate your egg to the Suikamon reserve in exchange for SUIKA.",
  "evolution.egg.yourEggAlt": "Your Egg",
  "evolution.egg.donateReward": "+{suika} SUIKA",
  "evolution.egg.donateExplain": "Your egg will be transferred to the Suikamon reserve. SUIKA goes to your Trainer balance, which you can transfer to any of your Suikamons.",
  "evolution.egg.donating": "Donating…",
  "evolution.egg.donate": "🎁 Donate",
  "evolution.found.openingTitle": "Opening your egg",
  "evolution.found.openingText": "Let's see who is inside…",
  "evolution.found.eggAlt": "Egg",
  "evolution.found.itsA": "🥚 It's a {species}!",
  "evolution.found.appeared": "🥚 A beautiful egg has appeared!",
  "evolution.found.foundSpecies": "{startsWithVowel, select, yes {You found an {rarity} <b>{species}</b> egg!} other {You found a {rarity} <b>{species}</b> egg!}}",
  "evolution.found.foundEgg": "You found an <b>Egg</b>!",
  "evolution.found.namePrompt": "What will you call this little one?",
  "evolution.found.creatingTitle": "Creating egg",
  "evolution.found.creatingText": "Generating secure randomness and creating your new egg…",
  "evolution.found.alreadyHave": "You already have {species}!",
  "evolution.found.thisSuikamon": "this Suikamon",
  "evolution.found.turnedInto": "The egg turned into <b>{amount}</b>",
  "evolution.found.hatchedAlt": "Hatched egg",
  "evolution.found.gotEgg": "You got an Egg!",
  "evolution.found.species": "🧬 Species: <b>{species}</b>",
  "evolution.found.rarity": "💎 Rarity: <b>{rarity}</b>",
  "evolution.found.failedTitle": "Failed",
  "evolution.found.failedText": "An error occurred. Please try again.",
  "evolution.found.nameRequired": "Pet name is required",
  "evolution.found.namePlaceholder": "Enter egg name ({min}-{max} characters)",
  "evolution.found.nameOk": "Name looks good!",
  "evolution.found.charCount": "{length}/{max}",
  "evolution.found.getEgg": "🥚 Get Egg",
  "evolution.found.backToPets": "Back to My Pets",
  "evolution.found.backToPetsEgg": "🥚 Back to My Pets",
  "evolution.found.tryAgain": "❌ Try Again",
  "evolution.species.playFree": "Play {species} free",
  "evolution.species.stageAlt": "{species}, evolution stage {stage}",
  "evolution.species.tokenHatch": "Evolution {stage}, at hatch",
  "evolution.species.tokenLevel": "Evolution {stage}, from level {level}",
  "evolution.species.tokensAria": "{species} evolution stages",
  "evolution.species.foundInEggs": "🥚 {species} is found in eggs",
  "evolution.species.playFreeAria": "Play {species} for free",
  "evolution.species.playStarterAria": "Play a free starter Suikamon",
  "evolution.species.tryLab": "Try it in the Battle Lab",
  "evolution.species.battleSkills": "Battle skills",
  "evolution.species.combatStyle": "Combat style",
  "evolution.species.clusterAllies": "Cluster allies:",
  "evolution.species.stagesTitle": "Evolution stages",
  "evolution.species.stagesLine": "{count, plural, one {{species} evolves through # stage, on its own, as it levels up.} other {{species} evolves through # stages, on its own, as it levels up.}}",
  "evolution.species.stageCard": "Stage {stage}",
  "evolution.species.stageHatch": "Hatch",
  "evolution.species.stageLevel": "Level {level}",
  "evolution.species.factsTitle": "Quick facts",
  "evolution.species.howToGet": "🥚 How to get",
  "evolution.species.freeStarter": "Free starter — pick it when you start",
  "evolution.species.soulDust": "Found with Soul Dust — win battles to recover its soul",
  "evolution.species.rarity": "Rarity: <b>{rarity}</b>",
  "evolution.species.growth": "📈 Growth",
  "evolution.species.stageCount": "Evolution stages: <b>{count}</b>",
  "evolution.species.xpPerCare": "XP per care: <b>{min}-{max}</b>",
  "evolution.species.combat": "⚔️ Combat",
  "evolution.species.element": "Element: <b>{element}</b>",
  "evolution.species.signature": "Signature move: <b>{move}</b>",
  "evolution.species.hpAtLevel": "HP at Lv{level}: <b>{hp}</b>",
  "evolution.species.availability": "🔗 Availability",
  "evolution.species.statusAvailable": "Status: <b>Available</b>",
  "evolution.species.statusUnavailable": "Status: <b>Unavailable</b>",
  "evolution.species.priceFree": "Price: <b>Free to play</b>",
  "evolution.collection.title": "The Collection",
  "evolution.collection.count": "{count, plural, one {# card} other {# cards}}",
  "evolution.collection.cardLabel": "{species}, stage {stage}",
  "evolution.collection.idStage": "#{id} · Stage {stage} / {maxStage}",
  "evolution.collection.evolutionChain": "Evolution chain",
  "evolution.collection.skillsTitle": "Skills & Combat",
  "evolution.collection.stageLevel": "Stage {stage} · Level {level}",
  "evolution.collection.startFree": "🌱 Start free with {species}",
  "evolution.collection.comingSoonText": "This Suikamon hasn't hatched into the world yet. Full stats, lore, and adoption reveal soon.",
  "evolution.hatch.failed": "Could not hatch right now",
  "evolution.hatch.ariaHatched": "{species} hatched",
  "evolution.hatch.ariaHatch": "Hatch {species}",
  "evolution.hatch.giftYours": "{species} is yours!",
  "evolution.hatch.found": "You found {species}!",
  "evolution.hatch.meet": "Meet {name}",
  "evolution.hatch.giftTitle": "A gift: {species}",
  "evolution.hatch.giftText": "Its egg is waiting for you. Name it:",
  "evolution.hatch.trackedTitle": "You tracked down {species}",
  "evolution.hatch.trackedText": "{icon} {goal} {currency} lead to its egg. Name it:",
  "evolution.hatch.nameLabel": "Name your Suikamon",
  "evolution.hatch.suggest": "Suggest another name",
  "evolution.hatch.hatching": "Hatching…",
  "evolution.hatch.hatch": "Hatch",
  "evolution.dialog.titleLevel": "<b>{petName}</b> is about to level up!",
  "evolution.dialog.titleEvolve": "<b>{petName}</b> is about to evolve!",
  "evolution.dialog.shareOffer": "Share this moment and earn <bonus>+{xp} XP</bonus> bonus!",
  "evolution.dialog.share": "Share",
  "evolution.dialog.thanks": "💜 Thanks for sharing! <bonus>+{xp} XP</bonus>",
  "evolution.dialog.levelUpNow": "⭐ Level Up Now!",
  "evolution.dialog.evolveNow": "🧬 Evolve Now!",
  "evolution.dialog.skipHint": "You can skip sharing.",
  "evolution.starter.title": "Choose your starter",
  "evolution.starter.invalidName": "Invalid pet name",
  "evolution.starter.failed": "Something went wrong. Please try again.",
  "evolution.starter.previous": "Previous starter",
  "evolution.starter.next": "Next starter",
  "evolution.starter.list": "Starters",
  "evolution.starter.choose": "Choose {species}, {element}",
  "evolution.starter.nameLabel": "Name",
  "evolution.starter.shuffle": "Shuffle name suggestion",
  "evolution.starter.waking": "Waking it up…"
}
